import { StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  itemContentContainer: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
    marginBottom: 5,
  }),
  rowContainer: {
    padding: 20,
  },
  rowItem: {
    flexDirection: 'row',
    paddingVertical: 10,
    alignItems: 'center'
  },
  itemRowTitle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regular,
    marginLeft: 16,
  },
  offerBottomContent: {
    backgroundColor: Colors.white,
    padding: 16,
  },
  descOfferStyle: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
  },
  offerIconsContainer: {
    flexDirection: 'row',
    marginVertical: 12,
  },
  itemIcon: {
    marginRight: 20,
  },
  offerBtnContainer: theme => ({
    borderTopWidth: 1,
    borderTopColor: theme.colors.borderColorThree,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    paddingBottom: 20,
  }),
  btnStyle: {
    marginTop: 20,
    marginBottom: 0,
  },
  titleOfferStyle: {
    color: Colors.dark_grey,
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  offerCardStyle: {
    marginHorizontal: 0,
    marginTop: 20,
  },
})
